import React from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues, SubmissionError } from 'redux-form'
import { Button, Breadcrumb } from 'semantic-ui-react'
import { lower } from 'change-case'
import { Collapse } from '@material-ui/core'

import { requestForQuotationPath } from 'routes'
import { MainBodyContent, CustomButton } from 'components'
import { scrollToFirstValidateFailElement } from 'core/utilities'
import Attachment from '../Form/Attachment'
import RequestInfo from '../Form/RequestInfo'
import General from '../Form/General'
import { validateAttachments, validateQuotationAttachments, validateField } from '../helper'
import { initializeRFQ, clearRFQData, saveRFQ, getRFQGOAWorkFlowEditMode,
  clearReload, getGOAItem
} from 'ducks/rfq'
import { getProjectByCompany } from 'ducks/goa'
import { getPurchaseUsers } from 'ducks/member'
import { showModal, toastError } from 'ducks/app'
import { BottomActionsContainer } from './styled'
import { RFQStdCont } from '../styled'
// import r from 'reactotron-react-js'

const CreateRequestForQuotation = props => {
  const { change, valueForm, sapDetails, history, isDetail = false } = props

  const [actionName, setActionName] = React.useState('')

  React.useEffect(() => {
    window.scrollTo(0, 0)
    props.initializeRFQ(isDetail)
    return (() => {
      props.clearRFQData()
    })
  }, [])

  React.useEffect(() => {
    if (sapDetails.companyCode) {
      if (props.projects[sapDetails.companyCode] === undefined) {
        if (sapDetails.companyCode !== props.projectCompanyLoading) {
          props.getProjectByCompany(sapDetails.companyCode)
        }
      }
      props.getPurchaseUsers(valueForm.companyCode, valueForm.purchasingGroup)
    }
  }, [valueForm.companyCode])

  React.useEffect(() => {
    if (valueForm.amountAfterDiscount) {
      props.getGOAItem(valueForm.companyCode, valueForm.amountAfterDiscount, valueForm.currencyCode)
    }
  }, [valueForm.amountAfterDiscount])

  React.useEffect(() => {
    props.clearReload()
  }, [props.sapDetailReload])

  React.useEffect(() => {
    props.getRFQGOAWorkFlowEditMode({
      creater: lower(props.userName),
      requester: valueForm.requesterUser || '',
      companyCode: valueForm.companyCode || '',
      goaItemCode: valueForm.goaItemCode || '',
      amount: valueForm.netAmount || '',
      currency: valueForm.currencyCode || '',
      alternativeUserName: valueForm.alternativePurchaseUser || '',
      purchaseGroup: valueForm.purchasingGroup || ''
    })
  }, [valueForm.createdByUser, valueForm.requesterUser, valueForm.goaItemCode, 
    valueForm.netAmount, valueForm.alternativePurchaseUser, valueForm.purchasingGroup ])

  const onSubmitForm = () => {
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))
    return sleep(100)
      .then(() => {
        let errors = validateField(valueForm)
        // r.log({ errors, valueForm })
        if (errors.rfqItemVendorTotalAmounts) {
          props.toastError(`The Discount Amount can't be more than Total Amount,Please check again.`)
        }
        if (Object.keys(errors).length) {
          scrollToFirstValidateFailElement(errors)
          throw new SubmissionError(errors)
        } else {
          valueForm.rfqAttachments = valueForm.rfqAttachments.filter(x => valueForm.documentTypes.findIndex(d => d.code === x.documentTypeCode) >= 0)

          if (actionName === 'save') {
            props.saveRFQ(valueForm, history, false)
          } else {
            let missingAttachments = validateAttachments(valueForm)
            let missingQuotationAttachments = validateQuotationAttachments(valueForm.rfqItemVendorQuatationAttachtments, valueForm.vendorQuatationAttachtments)
            if (missingAttachments.length) {
              props.showModal(
                true,
                'Please attach document!',
                <React.Fragment><ul>{missingAttachments.map(v => <li>{v.fieldName}</li>)}</ul></React.Fragment>
              )
            } else if (!missingQuotationAttachments) {
              props.showModal(
                true,
                'Please attach document!',
                <React.Fragment><ul><li>vendor quotation</li></ul></React.Fragment>
              )
            } else {
              props.saveRFQ(valueForm, history, true)
            }
          }
        }
      })
  }

  const vendorSelected = () => {
    return (valueForm.rfqItemVendorTotalAmounts || []).find(v => v.isVendorSelected) || {}
  }

  return (
    <MainBodyContent
      headerTitle='Request for Quotation - Create'
      accessoriesHeader={
        <div style={{ display: 'flex' }}>
          <CustomButton
            onClick={() => history.push(requestForQuotationPath)}
            icon='close'
            btnColor='red'
            title='Cancel'
          />
        </div>
      }
      breadcrumbs={
        <Breadcrumb
          icon='right angle'
          sections={[
            {
              key: 'RFQ',
              content: 'Request for Quotation',
              link: true,
              onClick: () => history.push(requestForQuotationPath),
            },
            { key: 'RFQCreate', content: 'Create', active: true },
          ]}
        />
      }
    >
      <RFQStdCont>
        <RequestInfo isCreate={true} change={change} />
        <General isCreate={true} isEdit={false} change={change} valueForm={valueForm} />
        <Collapse in={valueForm && valueForm.status >= 0} timeout={500}>
          <Attachment isCreate={true} change={change} />
        </Collapse>
        <form onSubmit={props.handleSubmit(() => onSubmitForm())}>
          <React.Fragment>
            {
              (vendorSelected().cocStatus === 15 || vendorSelected().cocStatus === 17) && vendorSelected().cocMessage ?
              <div 
                style={{ 
                  display: 'flex',
                  justifyContent: 'right',
                  whiteSpace: 'pre-wrap', 
                  fontWeight: 'bold',
                  textAlign: 'right',
                  color: 'orange' 
                }}
              >
                {vendorSelected().cocMessage}
              </div> : null
            }
            {
              (vendorSelected().vendorRegisterStatus || {}).registered === false ? 
                <div 
                  style={{ 
                    display: 'flex',
                    justifyContent: 'right',
                    whiteSpace: 'pre-wrap', 
                    fontWeight: 'bold',
                    textAlign: 'right',
                    color: 'orange' 
                  }}
                >
                  {`Supplier ${vendorSelected().vendorCode} : ${vendorSelected().vendorName} does not register EzProcure.`}
                </div> : null
            }
            <BottomActionsContainer>
              <Button
                type='submit'
                content='Save'
                icon='save'
                labelPosition='right'
                style={{ marginRight: '5px' }}
                onClick={() => setActionName('save')}
              />
              <Button
                type='submit'
                content='Save & Submit'
                color='blue'
                icon='save'
                labelPosition='right'
                // disabled={vendorSelected().cocStatus === 15}
                style={{ marginRight: '5px' }}
                onClick={() => setActionName('submit')}
              />
            </BottomActionsContainer>
          </React.Fragment>
        </form>

      </RFQStdCont>
    </MainBodyContent>
  )

}

const mapStateToProps = (state, props) => {
  const date = new Date()
  const projectCompanyLoading = state.goa.projectCompanyLoading
  const projects = state.goa.projects
  //Get default requesterUser
  const userName = state.authen.user ? state.authen.user.username ? state.authen.user.username : '' : ''
  let requesterUser = ''
  if (userName) {
    requesterUser = lower(userName)
  }
  var valueForm = getFormValues('formRFQ')(state) || {}
  var sapDetails = state.rfq.sapDetails
  if (sapDetails.isReload) {
    sapDetails.data = {
      ...sapDetails.data,
      title: valueForm.title || '',
      requesterUser: valueForm.requesterUser || requesterUser,
      category: valueForm.category || '',
      documentDate: (valueForm.documentDate) || new Date(date.getFullYear(), date.getMonth(), date.getDate()),
      goaItemCode: valueForm.goaItemCode || '',
    }
  }
  return ({
    initialValues: {
      requesterUser: requesterUser,
      documentDate: new Date(date.getFullYear(), date.getMonth(), date.getDate()),
      ...sapDetails.data,
    },
    sapDetails: sapDetails.data || {},
    sapDetailReload: sapDetails.isReload,
    projects,
    userName,
    projectCompanyLoading,
    valueForm
  })
}
const mapDispatchToProps = {
  initializeRFQ,
  getProjectByCompany,
  clearRFQData,
  saveRFQ,
  getRFQGOAWorkFlowEditMode,
  showModal,
  clearReload,
  toastError,
  getGOAItem,
  getPurchaseUsers
}

const contForm = reduxForm({
  form: 'formRFQ',
  enableReinitialize: true,
})(CreateRequestForQuotation)

export default connect(mapStateToProps, mapDispatchToProps)(contForm)
